import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { Icons } from 'src/app/modules/shared/enum/icons';
import { AccountingService } from 'src/app/modules/shared/services/api/accounting.service';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { ToastService } from 'src/app/modules/shared/services/toast.service';

@Component({
    selector: 'app-totp-code-dialog',
    templateUrl: './totp-code-dialog.component.html',
    styleUrls: ['./totp-code-dialog.component.scss'],
    standalone: true,
    imports: [FormsModule, MatDialogTitle, MatDialogContent, MatDialogActions, MatButton]
})
export class TotpCodeDialogComponent {
  dialogRef = inject<MatDialogRef<TotpCodeDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private toastService = inject(ToastService);
  private accountingService = inject(AccountingService);

  icons = Icons;
  totp = null;
  confirm() {
    if (this.totp) {
      if (this.data.needToVerify) {
        this.accountingService
          .verify2FA(this.data.token, this.totp)
          .subscribe((res) => {
            this.toastService.show({
              message: res?.detail,
              type: 'success',
              duration: 3000
            });
            this.dialogRef.close(true);
          });
      } else {
        this.dialogRef.close(this.totp);
      }
    }
  }
}
